<cyber-header></cyber-header>
<vhv-sidebar></vhv-sidebar>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<cyber-modal-area></cyber-modal-area>
